import React from 'react';
import { Button } from './Button';
const CHECKOUT_URL = 'https://www.lunaycalma.com/cart/46841754419354:1';
export function HeroSection() {
  return <section className="relative w-full min-h-screen bg-gradient-to-br from-emerald-900 via-teal-800 to-cyan-900 text-white overflow-hidden" data-id="element-188">
      {/* Background overlay */}
      <div className="absolute inset-0 bg-black/20" data-id="element-189"></div>

      <div className="relative max-w-7xl mx-auto px-6 py-20 lg:py-32" data-id="element-190">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-191">
          {/* Left: Copy */}
          <div className="text-center lg:text-left space-y-8" data-id="element-192">
            <h1 className="font-serif text-5xl lg:text-7xl leading-tight" data-id="element-193">
              Sobrevive a la{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-cyan-400" data-id="element-194">
                Quincena
              </span>
            </h1>

            <p className="text-2xl lg:text-3xl text-gray-200 leading-relaxed font-light" data-id="element-195">
              El método simple para dejar de vivir con ansiedad cada quincena y
              empezar a controlar tu dinero desde hoy.
            </p>

            <div className="space-y-4 pt-4" data-id="element-196">
              <Button size="lg" className="w-full sm:w-auto bg-gradient-to-r from-emerald-500 to-cyan-500 hover:from-emerald-600 hover:to-cyan-600" href={CHECKOUT_URL} data-id="element-197">
                👉 Quiero dejar de sufrir cada quincena
              </Button>

              <p className="text-sm text-gray-300" data-id="element-198">
                Compra segura • Descarga inmediata • Soporte en español
              </p>
            </div>
          </div>

          {/* Right: Hero Image */}
          <div className="relative" data-id="element-199">
            <div className="relative z-10 transform hover:scale-105 transition-transform duration-500" data-id="element-200">
              <img src="https://cdn.magicpatterns.com/uploads/q3FcGqGMwQVZL9GK8NVq6q/ChatGPT_Image_19_dic_2025,_12_22_05.png" alt="Sobrevive a la Quincena" className="w-full rounded-3xl shadow-2xl" data-id="element-201" />
            </div>
            {/* Decorative elements */}
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-emerald-400 rounded-full blur-3xl opacity-30" data-id="element-202"></div>
            <div className="absolute -bottom-6 -left-6 w-40 h-40 bg-cyan-500 rounded-full blur-3xl opacity-30" data-id="element-203"></div>
          </div>
        </div>
      </div>
    </section>;
}